<template>
  <div class="widget-container">
    <div class="d-flex flex-row flex-md-column flex-lg-row mb-1">
      <div class="image">
        <img
          src="@/assets/images/common/sales-person.svg"
          alt="sales person"
          height="48"
          width="48"
          class="mr-3"
        />
      </div>
      <div class="content d-flex flex-column">
        <p class="header mb-1">
          {{ $t('dashboard.requestCallbackWidget.header.prepend') }} <br />
          {{ $t('dashboard.requestCallbackWidget.header.append') }}
        </p>
      </div>
    </div>
    <div class="mb-2">
      <p class="sub-header">
        {{ $t('dashboard.requestCallbackWidget.subHeader') }}
      </p>
    </div>
    <div class="manager-info">
      {{ $t('dashboard.requestCallbackWidget.description') }}
      <b>{{ name ? name + ':' : '' }}</b> {{ email }}
      {{ phone ? '/ ' + phone : '' }} OR
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="!callbackMessageSent"
      @click="sentCallback"
    >
      <div class="callback-button">
        <b-icon-arrow-repeat
          animation="spin"
          class="mr-3"
          v-if="callbackFulfilled"
        />
        <b-icon-telephone class="mr-3" v-else />
        {{ $t('dashboard.requestCallbackWidget.buttonText') }}
      </div>
    </div>
    <div class="success-message" v-if="callbackMessageSent === 'success'">
      <b-icon-check-circle
        font-scale="1.1"
        class="mt-2 mr-3 color-dark-green"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidget.successMessage') }}</div>
    </div>
    <div class="success-message error" v-if="callbackMessageSent === 'failed'">
      <b-icon-x-circle
        font-scale="1.1"
        class="mr-3 color-advanced-red"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidget.errorMessage') }}</div>
    </div>
  </div>
</template>
<script>
import exportersService from '@/services/exporters'

export default {
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      callbackFulfilled: false,
      callbackMessageSent: false
    }
  },
  mounted() {
    exportersService
      .fetchExporterMetaData(this.$store.state.account.accountId, {
        include: ['relationship_manager']
      })
      .then((res) => {
        const manager = res.data.relationship_manager
        if (manager) {
          this.name = manager.name
          this.email = manager.email
          this.phone = manager.phone
        }
      })
  },
  methods: {
    sentCallback() {
      if (!this.callbackFulfilled) {
        this.$mpTrack(
          'Clicks "Request a callback" on the "We can beat your bank rate!" tile'
        )
        const accountId = this.$store.state.account.accountId
        this.callbackFulfilled = true
        exportersService
          .requestAMCallback(accountId)
          .then((res) => {
            if (res.data === 'Slack Alert Sent') {
              this.callbackMessageSent = 'success'
            }
            if (res.data !== 'Slack Alert Sent') {
              this.callbackMessageSent = 'failed'
            }
            this.callbackFulfilled = false
          })
          .catch((err) => {
            console.log(err)
            this.callbackMessageSent = 'failed'
            this.callbackFulfilled = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.widget-container {
  background: $sky-blue-50;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  .content {
    .header {
      color: $noble-blue-500;
      font-weight: 700;
      font-size: 20px;
      line-height: 23px;
    }
  }
  .sub-header {
    color: $noble-blue-500;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
  }
  .manager-info {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .callback-button {
    font-family: 'Nunito Sans';
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: $wealthy-green-500;
    cursor: pointer;
    margin-top: 8px;
    &:hover {
      background: $wealthy-green-50;
      text-decoration: underline;
    }
  }
  .success-message {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    padding: 16px;
    color: $noble-blue-500;
    background: $spring-green-100;
    border: 1px solid $spring-green-600;
    border-radius: 8px;
    margin-top: 12px;
    &.error {
      background: $red-100;
      border: 1px solid $red-400;
      align-items: center;
    }
  }
}
</style>
